import { render } from "./CharacterShow.vue?vue&type=template&id=6004972f&scoped=true"
import script from "./CharacterShow.vue?vue&type=script&lang=js"
export * from "./CharacterShow.vue?vue&type=script&lang=js"

import "./CharacterShow.vue?vue&type=style&index=0&id=6004972f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6004972f"

export default script